/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import s from './styles.module.scss';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { selectCommonReducer } from '@/state/common';
import ProposalSide from '@/modules/AlphaPWA/DirectMessage/Chat/Proposal/Result/side';
import { getProposalDetail } from '@/services/governor';
import { WalletContext } from '@/contexts/wallet-context';
import Countdown from '@/components/ActivityTopBar/Countdown';
import moment from 'moment';
import { formatCurrency } from '@/utils';
import { labelAmountOrNumberAdds } from '@/modules/AlphaPWA/Profiles/TradeKey/constants';
import BigNumber from 'bignumber.js';

export const PERCENT_QUORUM = 5;

const ProposalResult = ({ proposal }: any) => {
  const needReload = useSelector(selectCommonReducer).needReload;
  const [voteResult, setVoteResult] = useState<any>();
  const { addressL2 } = useContext(WalletContext);
  const [proposalDetail, setProposalDetail] = useState<any>(null);

  useEffect(() => {
    if (proposal && addressL2) {
      fetchTreasury();
    }
  }, [proposal, addressL2, needReload]);

  const fetchTreasury = async () => {
    const [propsal] = await Promise.all([
      getProposalDetail(proposal?.proposal_id, { address: addressL2 || '' }),
    ]);

    setProposalDetail(propsal);
  };

  const expiredTimeAt = useMemo(() => {
    if (moment().isBefore(moment(proposal?.vote_start_at))) {
      return proposal?.vote_start_at;
    } else {
      return proposal?.vote_end_at;
    }
  }, [proposal]);

  const minRequire = useMemo(() => {
    return new BigNumber(proposal?.supply)
      .multipliedBy(PERCENT_QUORUM)
      .div(100)
      .toNumber();
  }, [proposal]);

  return (
    <Flex direction={'column'} gap={4}>
      <Flex alignItems={'center'} justifyContent={'space-between'} mb="8px">
        <Flex gap={1} color={'#FFFFFF'} fontWeight={600} minW="60%">
          <Text opacity={'70%'} fontSize={'14px !important'}>
            Quorum
          </Text>{' '}
          <Text fontSize={'14px !important'}>
            {formatCurrency(minRequire)} key
            {labelAmountOrNumberAdds(minRequire)} ({PERCENT_QUORUM}%)
          </Text>
        </Flex>
        {proposal?.status !== 'cancel' ? (
          <Countdown className={s.timer} expiredTime={expiredTimeAt} />
        ) : (
          <Text
            textAlign="right"
            color={'#FFFFFF'}
            fontSize="14px"
            fontWeight={600}
          >
            Canceled
          </Text>
        )}
      </Flex>
      <>
        <ProposalSide
          title={'For'}
          currentVote={proposalDetail?.total_support_weight}
          totalVote={proposal?.supply}
          data={proposalDetail?.votes['1']}
          className={cx(s.sideWrapper, s.sideFor)}
        />
        <ProposalSide
          title={'Against'}
          currentVote={proposalDetail?.total_unsupport_weight}
          totalVote={proposal?.supply}
          data={proposalDetail?.votes['0']}
          className={cx(s.sideWrapper, s.sideAgainst)}
        />
      </>
    </Flex>
  );
};

export default ProposalResult;
